import type {PageError} from '@github-ui/react-core/app-routing-types'
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import type {RefInfo} from '@github-ui/repos-types'
import React, {useMemo} from 'react'

export interface FilesPageInfo extends FilesPageInfoProps {
  copilotAccessAllowed: boolean
}

interface FilesPageInfoProps {
  refInfo: RefInfo
  path: string
  action: FilesPageAction
  error?: PageError
  copilotAccessAllowed?: boolean
  copilotSpacesEnabled?: boolean
  modelsAccessAllowed?: boolean
  modelsRepoIntegrationEnabled?: boolean
  isMarketplaceEnabled?: boolean
}

export type FilesPageAction = 'tree' | 'blob' | 'edit' | 'new' | 'blame'

const FilesPageInfoContext = React.createContext({} as FilesPageInfo)

export function FilesPageInfoProvider({children, ...props}: React.PropsWithChildren<FilesPageInfoProps>) {
  const value = useMemo(() => ({copilotAccessAllowed: false, ...props}), [props])

  return <FilesPageInfoContext value={value}>{children}</FilesPageInfoContext>
}

export function useFilesPageInfo() {
  return React.use(FilesPageInfoContext)
}

interface ReposAppPayload {
  helpUrl: string
  findFileWorkerPath: string
  findInFileWorkerPath: string
  githubDevUrl: string
}

export function useReposAppPayload() {
  return useAppPayload<ReposAppPayload>()
}
